export default "__VITE_ASSET__DkFSQsOi__"